"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignIn = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var mall_1 = require("../../model/mall");
var service_1 = require("../../../library/base/service");
var SignIn = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SignIn, _super);
    function SignIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分签到';
        _this.code = '101154';
        _this.desc = '积分签到接口';
        _this.requestParams = new mall_1.SignInRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SignIn;
}(service_1.BaseService));
exports.SignIn = SignIn;
//# sourceMappingURL=signIn.js.map